/**
 * 成人模式提示条。
 *
 * 公告已经移到外壳顶部的滚动条（Layout 的 Marquee），这里只留成人模式提示，
 * 免得同一条公告在一个页面上出现两遍。
 */
import { usePlatform } from "../lib/bootstrap.tsx";

export function PlatformNotices() {
  const { settings } = usePlatform();

  if (!settings.adultMode) return null;

  return (
    <div className="mb-3 flex items-center gap-2 rounded-xl border border-danger/40 bg-danger/10 px-3 py-2 text-[11px] text-danger">
      <span className="badge-18">18+</span> 成人模式已开启：内容仅限成年人，请自行判断并尊重对方边界。
    </div>
  );
}
